import React, { useState } from 'react';
import { Button, FormWithRedirect, required, SaveButton, TextInput, useNotify } from 'react-admin';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import IconCancel from '@material-ui/icons/Cancel';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { availableMessageTemplates, serverApiUrl } from '../../../config/constants';
import httpClient from '../../../core/httpClient';
import UserAutocompleteInput from '../../UserAutocompleteInput';

import styles from './SendToSingleUser.module.scss';

const SendToSingleUser = ({ endpointUrl, recordKey, record }) => {
  const notify = useNotify();
  const [isOpen, setOpenStatus] = useState(false);

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setOpenStatus(true);
  };

  const handleCloseModal = () => {
    setOpenStatus(false);
  };

  const handleSendMessage = ({ user_id, message, caption }) => {
    const url = `${serverApiUrl}${endpointUrl}`;
    const body = JSON.stringify({ message, caption, user_id, [recordKey]: record.id });
    const options = { method: 'POST', body };

    httpClient(url, options)
      .then(() => handleCloseModal())
      .catch(() => notify("Error: Message wasn't sent", 'warning'));
  };

  return (
    <>
      <IconButton onClick={handleOpenModal}>
        <PersonOutlineIcon />
      </IconButton>
      <Dialog open={isOpen} onClick={(e) => e.stopPropagation()}>
        <DialogTitle>Send to user</DialogTitle>
        <FormWithRedirect
          save={handleSendMessage}
          render={({ handleSubmitWithRedirect, submitting, pristine }) => (
            <>
              <DialogContent className={styles.dialogContent} dividers>
                <UserAutocompleteInput source="user_id" validate={required()} />
                <TextInput label="Caption" source="caption" />

                <TextInput
                  helperText={`Available replacements: ${availableMessageTemplates.join(', ')}`}
                  label="Message"
                  source="message"
                  validate={required()}
                />
              </DialogContent>
              <DialogActions>
                <SaveButton disabled={submitting || pristine} handleSubmitWithRedirect={handleSubmitWithRedirect} />
                <Button label="ra.action.cancel" onClick={handleCloseModal}>
                  <IconCancel />
                </Button>
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

export default SendToSingleUser;
